import { BackButton } from "@4uhub/lib4uhub";
import { Box, Typography } from "@mui/material";
import { memo } from "react";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import { IHeaderProps } from "./models";

export const Header = memo(({ name, onBack }: IHeaderProps) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <BackButton onClick={onBack} />
      <Box
        sx={(t) => ({
          px: 3,
          py: 1,
          display: "flex",
          gap: 1,
          border: `1px solid ${t.palette.divider}`,
          borderRadius: t.shape.borderRadius,
        })}
      >
        <DashboardRoundedIcon />
        <Typography>{name}</Typography>
      </Box>
    </Box>
  );
});
